// extracted by mini-css-extract-plugin
export default {"content":"PageContent_content__gfHID","content__section":"PageContent_content__section__MyIXM"};